import styled from "styled-components";
import AntCheckbox from "uiKits/Checkbox";
import AntInput from "uiKits/Input";
import AntRadioButton from "uiKits/RadioButons";
import { media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const InnerContainer = styled.div`
  padding: 30px;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  box-sizing: border-box;

  ${media.downTablet`
    padding: 20px 16px;
  `}

  ${media.downMobile`
    padding: 16px 12px;
  `}
`;

export const PaymentWidgetWrap = styled.div`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
`;

export const MainHeading = styled.h3`
  margin: 20px 0px 20px 0px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 20px;
  `}
`;

export const InputWrapper = styled.div`
  padding-top: 20px;
`;

export const StyledInput = styled(AntInput)`
  background: #fff;
  height: 42px;
  min-height: 44px;
  width: 100%;
`;

export const CheckBoxWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 30px;
`;

export const StyledCheckBox = styled(AntCheckbox)`
  .ant-checkbox-inner {
    width: 22px;
    height: 22px;
  }
  .ant-checkbox-wrapper {
    font-size: 18px;
  }
`;

export const RadioWrapper = styled.div`
  width: 100%;
`;

export const RadioInnerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 50px;
  margin-top: 20px;
  flex-wrap: wrap;

  label {
    font-size: 18px;
  }

  ${media.downTablet`
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  `}
`;

export const StyledRadioButton = styled(AntRadioButton)`
  .ant-radio-inner {
    width: 22px;
    height: 22px;
  }
  .ant-radio-wrapper {
    font-size: 18px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }
`;

export const StyledCurrentAddress = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-break: break-word;

  ${media.downMobile`
    font-size: 16px;
  `}
`;
